import { useState } from 'react';
import { db } from '../firebase';
import { doc, setDoc, deleteDoc, serverTimestamp } from 'firebase/firestore';
import { CATEGORIES } from '../constants';

export default function UserProfileModal({ targetUid, targetName, currentUser, followingIds, pins, onClose }) {
  const [loading, setLoading] = useState(false);

  const isFollowing = followingIds.includes(targetUid);
  const isSelf = currentUser?.uid === targetUid;
  const userPins = pins.filter(p => p.uid === targetUid);

  const handleFollow = async () => {
    if (!currentUser || isSelf) return;
    setLoading(true);
    try {
      const docId = `${currentUser.uid}_${targetUid}`;
      if (isFollowing) {
        await deleteDoc(doc(db, 'follows', docId));
      } else {
        await setDoc(doc(db, 'follows', docId), {
          followerId: currentUser.uid,
          followingId: targetUid,
          createdAt: serverTimestamp(),
        });
      }
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10000, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ background: 'white', borderRadius: '16px 16px 0 0', padding: 24, width: '100%', maxWidth: 480, maxHeight: '75vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 16 }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22 }}>
              👤
            </div>
            <div>
              <p style={{ margin: 0, fontWeight: 600, fontSize: 16 }}>{targetName}</p>
              <p style={{ margin: 0, fontSize: 12, color: '#999' }}>핀 {userPins.length}개 진행 중</p>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {currentUser && !isSelf && (
              <button
                type="button"
                onClick={handleFollow}
                disabled={loading}
                style={{
                  padding: '8px 16px', borderRadius: 20, fontSize: 13, fontWeight: 500, cursor: loading ? 'default' : 'pointer',
                  border: isFollowing ? '1.5px solid #ddd' : 'none',
                  background: isFollowing ? 'white' : '#333',
                  color: isFollowing ? '#333' : 'white',
                }}
              >
                {loading ? '...' : isFollowing ? '팔로잉' : '+ 팔로우'}
              </button>
            )}
            {!currentUser && !isSelf && (
              <span style={{ fontSize: 12, color: '#999' }}>로그인 후 팔로우 가능</span>
            )}
            <button type="button" onClick={onClose} style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer' }}>✕</button>
          </div>
        </div>

        <div>
          <p style={{ margin: '0 0 10px', fontSize: 13, fontWeight: 500, color: '#555' }}>진행 중인 핀</p>
          {userPins.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#bbb', fontSize: 13, padding: '20px 0' }}>현재 진행 중인 핀이 없어요</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {userPins.map(pin => {
                const cat = CATEGORIES[pin.category] || CATEGORIES['user'];
                return (
                  <div key={pin.id} style={{ padding: 12, borderRadius: 10, border: '1px solid #eee', background: '#fafafa' }}>
                    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 4 }}>
                      <span style={{ fontSize: 11, background: '#E3F2FD', color: '#1565C0', padding: '2px 8px', borderRadius: 20 }}>
                        {cat.emoji} {cat.label}
                      </span>
                      {pin.alwaysOn && (
                        <span style={{ fontSize: 11, background: '#FFF3E0', color: '#E65100', padding: '2px 8px', borderRadius: 20 }}>🔄 상시운영</span>
                      )}
                      {pin.isUpcoming && (
                        <span style={{ fontSize: 11, background: '#F3E5F5', color: '#7B1FA2', padding: '2px 8px', borderRadius: 20 }}>📣 사전광고</span>
                      )}
                    </div>
                    {pin.title && <p style={{ margin: '0 0 2px', fontWeight: 600, fontSize: 14 }}>{pin.title}</p>}
                    <p style={{ margin: 0, fontSize: 12, color: '#666', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pin.content}</p>
                    {pin.eventDate && <p style={{ margin: '4px 0 0', fontSize: 11, color: '#999' }}>📅 {pin.eventDate}</p>}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
